import {useNavigate} from 'react-router-dom';
import StatusBadge from '../../../../components/statusBadge';
import {convertEnglishUnitToFa} from '../../../../global/helpers/convertEnUnitToFA';

interface IProps {
  item: IMyStoreBrand;
}

const StoreSubBrandCard = ({item}: IProps) => {
  const navigate = useNavigate();

  const mainImgSrc = (image: IImage) => {
    if (!image) return '';
    return (
      image.image ||
      image.image_1024 ||
      image.image_330 ||
      image.image_128 ||
      ''
    );
  };
  const clickHandler = () => {
    if (item.status !== 'accept') {
      return;
    }
    navigate(`subBrand/${item?.guid}`, {
      state: {
        subBrandId: item.id,
      },
    });
  };
  return (
    <div
      className="flex relative gap-3 justify-between items-center p-3 rounded-xl border shadow-sm"
      onClick={clickHandler}
    >
      <div className="flex gap-4 justify-center items-center">
        <img
          src={mainImgSrc(item?.image)}
          alt="brand"
          className="object-cover w-11 h-11 rounded-lg"
        />
        <div className="flex flex-col gap-2">
          <span className="text-md">{item?.name}</span>
          {item?.additional_data?.weight &&
            item?.additional_data?.weightUnit && (
              <span className="text-sm font-normal text-gray-600">
                {item?.additional_data?.weight}
                {' ' +
                  convertEnglishUnitToFa(item?.additional_data?.weightUnit)}
              </span>
            )}
        </div>
      </div>

      <div className="absolute top-3 left-3">
        {item?.status !== 'accept' && ( // Only show when an item's status is 'pending' or 'reject'
          <StatusBadge status={item?.status} />
        )}
      </div>
    </div>
  );
};

export default StoreSubBrandCard;
